import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { BodySecondary } from '@liveauctioneers/hammer-ui-core/text';

type Props = {
    count: number;
};

export const AuctionsNearMeAuctionHouseCount = ({ count }: Props) => {
    return (
        <BodySecondary className="hui-text-h3">
            {count === 1 ? (
                <FormattedMessage id="nearby_auction_houses_count_single" />
            ) : (
                <FormattedMessage
                    id="nearby_auction_houses_count"
                    values={{ numberOfHouses: count }}
                />
            )}
        </BodySecondary>
    );
};
